"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutUs() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-us" className="bg-background text-foreground py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        
        <div ref={textRef} className={`flex flex-col gap-6 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display !text-6xl !font-bold !text-[hsl(224,76%,48%)]">You May Be Owed Money — And Not Even Know It</h2>
          
          <div className="text-muted-foreground leading-relaxed">
            <p>If your home was foreclosed on or sold due to unpaid taxes, there’s a chance it sold for more than what was owed.</p>
            <br />
            <p>That extra money — known as surplus funds — may legally belong to you or your family.</p>
            <br />
            <p>The problem?</p>
            <p>Most people are never properly informed… and the process to claim it can be complicated.</p>
            <br />
            <p>That’s where we come in.</p>
          </div>
        </div>

        {}
        <div ref={imageRef} className={`flex justify-center md:justify-end transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          <div className="rounded-lg shadow-medium overflow-hidden max-w-md w-full">
            <img src="https://rrrecoverysolutions.com/wp-content/uploads/2026/04/Untitled-design-51.png" alt="John Smith, Founder & Lead Consultant" className="w-full h-auto object-cover aspect-[3/4]" />
          </div>
        </div>
      </div>
    </section>;
}